export enum UserManagementStatus {
  OP = 1,
  BR = 2,
  FP = 3,
  FR = 4,
  O = 5,
  R1 = 6,
  URP = 7,
  URR = 8,
  URA = 9,
  R2 = 10,
}

export const UserManagementStatusText: Record<UserManagementStatus, string> = {
  [UserManagementStatus.OP]: "Onboarding Pending",
  [UserManagementStatus.BR]: "Blitz In Review",
  [UserManagementStatus.FP]: "Full Onboarding Pending",
  [UserManagementStatus.FR]: "Full Onboarding In Review",
  [UserManagementStatus.O]: "Onboarded",
  [UserManagementStatus.R1]: "Rejected",
  [UserManagementStatus.URP]: "User Request Pending",
  [UserManagementStatus.URR]: "User Request Rejected",
  [UserManagementStatus.URA]: "User Request Approved",
  [UserManagementStatus.R2]: "Rejected",
};

export const getUserManagementStatusStyle = (
  status: UserManagementStatus,
): { bgColor: string; textColor: string; dotColor: string } => {
  switch (status) {
    case UserManagementStatus.O:
    case UserManagementStatus.URA:
      return {
        bgColor: "tw-bg-[#ECFDF3]",
        textColor: "tw-text-[#027A48]",
        dotColor: "tw-bg-[#12B76A]",
      };
    case UserManagementStatus.R1:
    case UserManagementStatus.R2:
    case UserManagementStatus.URR:
      return {
        bgColor: "tw-bg-[#FEF3F2]",
        textColor: "tw-text-[#B42318]",
        dotColor: "tw-bg-[#F04438]",
      };
    case UserManagementStatus.BR:
      return {
        bgColor: "tw-bg-[#F5F5F5]",
        textColor: "tw-text-[#414651]",
        dotColor: "tw-bg-[#717680]",
      };
    default:
      return {
        bgColor: "tw-bg-[#F5F5F5]",
        textColor: "tw-text-[#414651]",
        dotColor: "tw-bg-[#717680]",
      };
  }
};
